<template>
  <a-spin :tip="$t('Loading...')" :spinning="getting_data">
    <navbar :back_path="'/log?step=Activity'" />
    <div style="text-align: center; width: 100%; padding: 16px">
      <div style="background-color: #fff; padding: 8px" class="text-center">
        <label class="title fs-16"> ส่งหลักฐานการชำระเงิน </label>
        <img
          class="mr-2 ml-2 mt-16"
          v-if="previewImage"
          style="width: 40px; float: left"
          :src="previewImage"
        />
        <a-form-item style="font-weight: 600" class="w-700-box">
          <a-upload :showUploadList="false" @change="handleChange">
            <a-button
              class="text-center danger-btn ant-button-label-custom"
              style="width: 200px"
            >
              <strong class="fs-16">เลือกไฟล์รูปภาพ / ถ่ายภาพ</strong>
            </a-button>
          </a-upload>
        </a-form-item>
        <a-button
          v-if="previewImage"
          class="text-center danger-btn ant-button-label-custom"
          style="width: 200px"
          @click="sendData"
        >
          <strong class="fs-16">ส่งข้อมูล</strong>
        </a-button>
      </div>
    </div>
    <div style="text-align: center; width: 100%; padding: 16px; padding-top: 0">
      <div style="background-color: #fff; padding: 8px" class="text-center">
        <label class="title fs-16"> ข้อมูลผู้ติดตาม </label>
        <label class="description fs-16">
          โปรดเตรียมไฟล์เอกสารบัตรประชาชน / หรือหนังสือเดินทางให้ครบถ้วน
        </label>
        <a-button
          class="text-center danger-btn ant-button-label-custom"
          style="width: 150px"
          @click="r('/log-activity-follower', { activity })"
        >
          <strong class="fs-16">กรอกข้อมูล</strong>
        </a-button>
      </div>
    </div>
    <div style="text-align: center; width: 100%; padding: 16px; padding-top: 0">
      <div style="background-color: #fff; padding: 8px" class="text-center">
        <label class="title fs-16"> ข้อมูลผู้ถือหุ้นกู้ </label>
        <label class="description fs-16">
          โปรดเตรียมไฟล์เอกสารบัตรประชาชน / หรือหนังสือเดินทางให้ครบถ้วน
        </label>
        <a-button
          class="text-center danger-btn ant-button-label-custom"
          style="width: 150px"
          @click="r('/log-activity-data-detail', { activity })"
        >
          <strong class="fs-16">กรอกข้อมูล</strong>
        </a-button>
      </div>
    </div>
    <div v-if="$device != 'mobile'" class="copyright-section">
      © Copyright SCG Debenture Club. All Rights Reserved.
    </div>
  </a-spin>
</template>
<script>
import navbar from '../../components/navbar';
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  components: {
    navbar,
  },
  data: function () {
    return {
      getting_data: false,
      activity: this.$route.query.activity,
      previewImage: '',
      fileList: '',
    };
  },
  mounted() {},
  methods: {
    handleChange({ fileList }) {
      var length = fileList.length;
      if (length > 0) {
        if (fileList[length - 1] && fileList[length - 1].originFileObj) {
          this.fileList = fileList[length - 1].originFileObj;
          getBase64(fileList[length - 1].originFileObj, (imageUrl) => {
            this.previewImage = imageUrl;
          });
        }
      }
    },
    sendData() {
      const formData = new FormData();
      if (this.fileList) formData.append('file_payment', this.fileList);
      if (this.activity.apply_id)
        formData.append('apply_id', this.activity.apply_id);
      this.$store.dispatch('user/POST', {
        payload: {
          path: '/api/log/activity/payment',
          data: formData,
          callback: (res) => {
            console.log('res', res);
            const complete = {
              message: '',
            };
            if (res && res.result == 'complete') {
              for (const [key, value] of Object.entries(res.complete)) {
                if (key) {
                  complete.message += value[0];
                }
              }
              this.$confirm({
                message: complete.message,
                button: {
                  yes: 'ปิดหน้าต่าง',
                },
                callback: (confirm) => {
                  this.r('/log?step=Activity');
                },
              });
            } else {
              for (const [key, value] of Object.entries(res.errors)) {
                if (key) {
                  complete.message += value[0];
                }
              }
              this.$confirm({
                message: complete.message,
                button: {
                  yes: 'ปิดหน้าต่าง',
                },
                callback: (confirm) => {},
              });
            }
            this.getting_data = false;
          },
        },
      });
    },
  },
};
</script>
<style scoped>
.title {
  display: block;
  font-weight: 600;
  margin: 8px 0 0 16px;
  color: #000 !important;
}
.description {
  font-weight: 300;
  margin: 20px;
  color: #000 !important;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.w-700-box {
  width: 100%;
  display: inline-block;
  margin: 60px 0 0 0;
}
</style>
